import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar } from '@mui/material';
// contexts
import { useAuth } from '../../../contexts/AuthContext';
// utils
import { ADMIN_ROLES } from '../../../utils/format';
// components
import MenuPopover from '../../../components/MenuPopover';
import { IconButtonAnimate } from '../../../components/animate';

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const [open, setOpen] = useState(null);
  const { admin, logout } = useAuth();
  const navigate = useNavigate();

  const handleClose = () => setOpen(null);

  const go = (path) => {
    handleClose();
    navigate(path);
  };

  const initials = (admin?.fullName || 'A')
    .split(' ')
    .slice(0, 2)
    .map((s) => s[0])
    .join('');

  return (
    <>
      <IconButtonAnimate
        onClick={(e) => setOpen(e.currentTarget)}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar src={admin?.avatarUrl || undefined} sx={{ bgcolor: 'primary.main' }}>
          {initials}
        </Avatar>
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          '& .MuiMenuItem-root': { typography: 'body2', borderRadius: 0.75 },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {admin?.fullName}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {admin?.email}
          </Typography>
          <Typography variant="caption" sx={{ color: 'primary.main', fontWeight: 600 }} noWrap>
            {ADMIN_ROLES[admin?.role] || admin?.role}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          <MenuItem onClick={() => go('/dashboard/app')}>Обзор</MenuItem>
          <MenuItem onClick={() => go('/dashboard/settings')}>Настройки</MenuItem>
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem sx={{ m: 1, color: 'error.main' }} onClick={logout}>
          Выйти
        </MenuItem>
      </MenuPopover>
    </>
  );
}
